import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { KeyValuePair, KeyValuePairArray } from '../../models/KeyValuePair';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { xToastr, ToastrTypes } from '../../shared/Toastr';
import { ErrorEventArgs, IErrorEventArgs } from '../../models/event-args/global-error.event.args';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '@services/ss-api.service';
import { LoginWithGoogleRequest } from '@models/ss-api/requests/loginwithgoogle.request';
import { HttpError } from '@aspnet/signalr';

export enum FormTypes {
    SigninForm,
    SigninFormTest,
    TwoFactorChoiceForm,
    TwoFactorCodeForm,
    ForgotPasswordForm,
    GoogleAuthenticatorForm,
    Redirect,
}

@Component({
    selector: 'signin',
    templateUrl: './signin.component.html',
})
export class SigninComponent {

    private RedirectTo: string;

    TwoFactorOptions: KeyValuePairArray<string, string>;
    IsBusy: boolean = false;

    ShowSigninForm: boolean = true;
    ShowTwoFactorChoiceForm: boolean = false;
    ShowTwoFactorCodeForm: boolean = false;
    ShowForgotPasswordForm: boolean = false;
    ShowRedirect: boolean = false;
    ShowGoogleAuthenticator: boolean = false;
    ShowGoogleResponse: boolean = false;

    GoogleCode: string = "";
    EchoState: string = "";

    constructor(private router: Router, private route: ActivatedRoute, private gb: GlobalService, private api: ssApiService) {
        // subscribe and add to list

    }

	ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.code){
                    
                    //indicates we have received a google response - need to do some work
                    this.ShowSigninForm = false;
                    this.ShowGoogleResponse = true;

                    this.GoogleCode = params.code;
                    this.EchoState = params.state;
    
                    var storedstate = localStorage.getItem("google_state");
                    
                    localStorage.removeItem("google_state");
            
                    if (this.EchoState == storedstate){
                        let data = new LoginWithGoogleRequest();
                        data.GoogleCode = this.GoogleCode;
                        data.Checksum = 'SFHSDKFHSDFHsdkfsdf2s4df85s4df524sd5f4sSDNFNDFSDKFJsdkfowefhSDFSDfFaustoksdCaltabiano!!!sdfSDHFkds5246';
                
                        data.DeviceID = localStorage.getItem("DeviceID");
                        if (data.DeviceID == null || data.DeviceID == undefined)
                            data.DeviceID = "";

                        let request = this.api.LoginWithGoogle(data)
                            .subscribe(async response => {
                
                                if (!response.Result) {
                                    // error
                                    this.onError(new ErrorEventArgs('0', "", "", "An Error Occured Logging You In"));
                                    this.router.navigate(['/authentication']);            
                                    //reset display
                                    this.ShowSigninForm = true;
                                    this.ShowGoogleResponse = false;                                    
                                }
                
                                let data = response.Data;
                                if (!data.Authenticated && !data.TwoFactorRequired) {
                                    // not authenticated
                                    this.onError(new ErrorEventArgs('0', "", "", "An Error Occured Authenticating Your User"));
                                    this.router.navigate(['/authentication']);            
                                    //reset display
                                    this.ShowSigninForm = true;
                                    this.ShowGoogleResponse = false;                                    
                                }
                
                                // set data in globals
                                console.log(data);
                                this.gb.SetGlobalsFromLoginResponse(response.Data);
                                this.gb.ReadFromStorage();

                                if (data.TwoFactorRequired) {
                                    // todo => do we care about 2FA?
                                    //this.onTwoFactorRequired.emit(data.TwoFactorOptions);
                                    this.onTwoFactorRequired(data.TwoFactorOptions);
                                }
                                else
                                {
                                    localStorage.setItem('is_authenticated', "1");

                                    // setup user roles
                                    this.gb.LoadSignature();
                                    this.gb.SetupUserRole();
                                    this.gb.GetGravatar();

                                    this.onAuthenticated(response);
                                }
                            },
                
                                (error: HttpError) => {
                                    this.onError(new ErrorEventArgs('0', "", "", "An Error Occured Logging You In"));
                                    console.log("lre");
                                    this.router.navigate(['/authentication']);            
                                    //reset display
                                    this.ShowSigninForm = true;
                                    this.ShowGoogleResponse = false;
                                }
                            );   
                    }
                    else{
                        //Our code doesn't match.  Just show the standard login form
                        console.log("lrx");
                        this.router.navigate(['/authentication']);
                        //reset display
                        this.ShowSigninForm = true;
                        this.ShowGoogleResponse = false;
    
                    }

                }
                else{
                    //Default behavior - allow the defaults (login form) to apply
                }
            }         
        );
      
    }

    private HideAllForms() {
        this.ShowSigninForm = false;
        this.ShowTwoFactorChoiceForm = false;
        this.ShowForgotPasswordForm = false;
        this.ShowTwoFactorCodeForm = false;
        this.ShowRedirect = false;
        this.ShowGoogleAuthenticator = false;
        this.ShowGoogleResponse = false;
    }

    LoginWithGoogle(){
        var baseGoogleURL = "https://accounts.google.com/o/oauth2/auth";
        var clientID = "280651924237-j17nl08abbo1paqba4jfcjftut5qt41u.apps.googleusercontent.com";
        var redirectURI = window.location.href.toLowerCase();
        var scope = "email%20profile";
        var responseType = "code";

        var googleState = this.getUniqueId(7);
        localStorage.setItem("google_state", googleState);

        var googleLoginURL = baseGoogleURL + "?client_id=" + clientID + "&redirect_uri=" + redirectURI + "&state=" + googleState + "&scope=" + scope + "&response_type=" +  responseType;
        location.href = googleLoginURL;
    }

    getUniqueId(parts: number): string {
        const stringArr = [];
        for(let i = 0; i< parts; i++){
          // tslint:disable-next-line:no-bitwise
          const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
          stringArr.push(S4);
        }
        return stringArr.join('-');
      }    

    ShowForm(form: FormTypes) {

        // fadeout

        this.HideAllForms();

        switch (form) {

            case FormTypes.SigninForm:
                this.ShowSigninForm = true;
                break;

            case FormTypes.TwoFactorChoiceForm:
                this.ShowTwoFactorChoiceForm = true;
                break;

            case FormTypes.ForgotPasswordForm:
                this.ShowForgotPasswordForm = true;
                break;

            case FormTypes.TwoFactorCodeForm:
                this.ShowTwoFactorCodeForm = true;
                break;

            case FormTypes.GoogleAuthenticatorForm:
                this.ShowGoogleAuthenticator = true;
                break;

            case FormTypes.Redirect:
                this.ShowRedirect = true;
                break;

            default:
                this.ShowSigninForm = true;
                break;
        }
    }


    onBusyChanged(isBusy: boolean) {
        this.IsBusy = isBusy;
    }

    async onAuthenticated(ev: IBaseResponse<any>) {
        this.ShowForm(FormTypes.Redirect);
        let redirect = localStorage.getItem('loginRedirect');

        // AFTER AUHTENTICATION FETCH

        // get all the other info...
        // sales reps, just load. the global service will intercept the data.      
        await this.gb.GetSalesRepresentatives();
        await this.gb.GetStructureStudiosProductsBasics();
        await this.gb.GetAdmins();

        // wait
        setTimeout(() => {
            // load redirect
            if (ev.Redirect != null) {
                this.router.navigate([ev.Redirect]);
            } else if (redirect) {
                this.router.navigate([redirect]);
                localStorage.removeItem('loginRedirect');
            } else {
                this.router.navigate(['Dashboard']);
            }

        }, 2500);

    }

    onTwoFactorRequired(twoFactorOptions: KeyValuePairArray<string, string>) {
        this.TwoFactorOptions=  new  KeyValuePairArray<string, string>();
        this.TwoFactorOptions.push(new KeyValuePair<string, string>("GOOGLE", "Google Authenticator"))
        
        if (this.TwoFactorOptions != undefined)
        {
            twoFactorOptions.forEach(item =>
            {
                this.TwoFactorOptions.push(item);
            })
        }
     
        this.ShowForm(FormTypes.TwoFactorChoiceForm);
    }

    onTwoFactorCodeSent(formChoice: string = "") {

        if (formChoice == "GOOGLE")
            this.ShowForm(FormTypes.GoogleAuthenticatorForm);
        else
            this.ShowForm(FormTypes.TwoFactorCodeForm);

            this.IsBusy = false;
    }

    onForgotPassword() {
        this.ShowForm(FormTypes.ForgotPasswordForm);
    }

    onForgotPasswordCancel() {
        this.ShowForm(FormTypes.SigninForm)
    }

    onError(ev: IErrorEventArgs) {
        xToastr.ShowToast(ToastrTypes.Error, ev.FriendlyErrorTitle, ev.FriendlyErrorMessage);

        if (this.ShowTwoFactorChoiceForm)
            this.ShowForm(FormTypes.SigninForm);
    }

    onCancel() {

        if (this.ShowTwoFactorChoiceForm)
            this.ShowForm(FormTypes.SigninForm);
        else if (this.ShowTwoFactorCodeForm)
            this.ShowForm(FormTypes.TwoFactorChoiceForm);
        else
            this.ShowForm(FormTypes.SigninForm);
    }

}
